import { send } from '../../../../../../../../src/network';
import { type Cart } from '../../../../../../../../src/types/Cart';

export async function deleteBundleRequest(bundleId: number) {
  return send<Cart>({
    path: `/api/v2/customers/self/cart/bundles/${bundleId}/`,
    method: 'DELETE',
  });
}
